import { Box } from '@deckee/deck-hand';
import React, { FC } from 'react';
import { HIDDEN_BASE_LAYERS } from '../../../../services/map-style';
import { BASE_MAP_SUBTITLES, BaseMapDefinition } from '../mapSettingsConfig';
import LayerCard from './LayerCard';

interface BaseMapTabProps {
  baseMapDefinitions: Record<string, BaseMapDefinition>;
  selectedBaseMapLayer: string | null;
  onSelectBaseMap: (_baseMapLayer: string) => void;
  /** When off, subscriber-only base maps are not listed at all. */
  hasSubscriptionFeaturesEnabled: boolean;
}

const BaseMapTab: FC<BaseMapTabProps> = ({
  baseMapDefinitions,
  selectedBaseMapLayer,
  onSelectBaseMap,
  hasSubscriptionFeaturesEnabled,
}) => (
  <Box
    display="flex"
    flexDirection="column"
    gap="2"
    role="radiogroup"
    aria-label="Base map"
  >
    {Object.keys(baseMapDefinitions)
      // Only show types if the layer is meant to be available
      .filter((baseLayerType) => {
        if (HIDDEN_BASE_LAYERS.includes(baseLayerType)) {
          return false;
        }
        const config = baseMapDefinitions[baseLayerType];
        return hasSubscriptionFeaturesEnabled ? true : !config.subscriberOnly;
      })
      .map((baseLayerType) => {
        const config = baseMapDefinitions[baseLayerType];
        return (
          <LayerCard
            key={baseLayerType}
            title={config.displayName}
            subtitle={BASE_MAP_SUBTITLES[baseLayerType] ?? ''}
            imageUrl={config.iconImage}
            selected={selectedBaseMapLayer === baseLayerType}
            subscriberOnly={config.subscriberOnly}
            singleSelect
            onClick={() => onSelectBaseMap(baseLayerType)}
          />
        );
      })}
  </Box>
);

export default BaseMapTab;
